import React from "react";
import ConnectedErrorDisplay from "../../common/ErrorDisplay/ConnectedErrorDisplay";
import ConnectedMessageDisplay from "../../common/MessageDisplay/ConnectedMessageDisplay";
import ConnectedRecurringSummaryHeader from "../../Pages/RecurringSummaryPage/RecurringSummaryHeader";

/**
 * @param {object} props
 * @param {object} props.control
 * @returns {React.JSX.Element}
 */
const RecurringSummaryHeaderControl = ({ control }) => (
    <>
        <ConnectedErrorDisplay />
        <ConnectedMessageDisplay />
        <ConnectedRecurringSummaryHeader control={control} />
    </>
);

export default RecurringSummaryHeaderControl;
